import * as yup from 'yup';

export const validationSchema = yup.object({
  examinerLicenseNumber: yup.string(),
  expirationDate: yup.string(),
  verifiedLicenseNumber: yup.string(),
});
